// extracted by mini-css-extract-plugin
export default {"operationArea":"List_operationArea__LMbdU","modal":"List_modal__IPDll","image":"List_image__jRdXp"};